module.exports = __webpack_public_path__ + "media/images/front/bg_columns_header-5c42d2f90817449195edafb1ff5ed0cf.jpg";